(function(angular){
	'use strict';
	
	var notificationDropdownObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			investmentEntityId: '<'
		},
		controller: [
			'$cookies',
			'$element', 
			'$scope', 
			'$window',
			'urlFactory',
			'mixpanelFactory',
			NotificationDropdownFunction
		],
		controllerAs: 'notificationDropdown'
	};
	
	angular
		.module('navModule')
		.component('notificationDropdown', notificationDropdownObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/notification/notification-dropdown.html';
	}
	
	function NotificationDropdownFunction(
		$cookies,
		$element, 
		$scope, 
		$window,
		urlFactory,
		mixpanelFactory
	) {
		
		var notificationDropdown = this;
		
		var lastViewedTimestampCookieKey = 'com.fundrise.notifications.lastViewed';

		notificationDropdown.visible = false;

		notificationDropdown.clearUnreadNotifications = function() {
			var timestampJson = JSON.stringify({
					timestamp : notificationDropdown.generatedTimestamp
			});
			
			urlFactory.apiPostPromise('/api-secured/investment-entity/' + notificationDropdown.investmentEntityId + '/notifications', timestampJson);
			notificationDropdown.numUnreadNotifications = 0;
			$cookies.putObject(lastViewedTimestampCookieKey, Date.now(), { path: '/' });
		};

		notificationDropdown.$onInit = function() {
			
			urlFactory.apiGetPromise('/api-secured/investment-entity/' + notificationDropdown.investmentEntityId + '/recent-notifications')
				.then(function(response) {
					
					notificationDropdown.notifications = response.data.notifications;
					notificationDropdown.lastNotificationView = response.data.lastNotificationView;
					notificationDropdown.generatedTimestamp = response.data.generatedTimestamp;
					
					var browserViewTs = $cookies.getObject(lastViewedTimestampCookieKey);
					
					if(angular.isDefined(browserViewTs) && browserViewTs > notificationDropdown.generatedTimestamp) {
						notificationDropdown.numUnreadNotifications = 0;
					} else if(angular.isDefined(notificationDropdown.lastNotificationView)) {
						notificationDropdown.numUnreadNotifications = notificationDropdown.notifications.filter(function(notification) {
							return notification.displayDateMillis >= notificationDropdown.lastNotificationView;
						}).length;
					} else {
						notificationDropdown.numUnreadNotifications = notificationDropdown.notifications.length;
					}

				}, function(response) {
					urlFactory.handleFailedRequest(response);
				});
		};

		notificationDropdown.ignoreClose = function($event) {
			if ($event.stopPropagation) {
				$event.stopPropagation();
			}
		};

		notificationDropdown.setUpClose = function() {
			var page = angular.element($window);
			var element = $element[0];
			page.bind('click', function(event) {

				if(notificationDropdown.visible) {
					var ignoreClose = false;

					angular.forEach(event.path, function(domNode) {
						if(domNode === element) {
							ignoreClose = true;
						}
					});

					if(!ignoreClose) {
						notificationDropdown.visible = false;
						$scope.$apply();
					}
				}
			});
		};

		notificationDropdown.toggle = function($event) {
			if ($event.stopPropagation) {
				$event.stopPropagation();
			}

			if(notificationDropdown.numUnreadNotifications !== 0) {
				notificationDropdown.clearUnreadNotifications();
			}
			notificationDropdown.visible = !notificationDropdown.visible;
			notificationDropdown.setUpClose();

			if(notificationDropdown.visible) {
				mixpanelFactory.track('Notification Dropdown Opened', {
					'investmentEntityId': notificationDropdown.investmentEntityId
				});
			}
		};
		
	}
})(window.angular);